<template>

  <form id="profile" v-on:submit="save">
    <div class="card-body">
      <div class="tab-content">
        <div class="tab-pane active" id="activity">
          <div class="row">
            <div class="col-md-12">
              <h5 class="h4-t">Your Teaching Philosophy & Skills</h5>
              <hr />
            </div>
            <div class="col-md-12 col-sm-12" style="margin-bottom:50px">
              <quill-editor v-model="applicantEassy.Eassy" required />
            </div>
          </div>
        </div>
      </div>
      <!-- /.tab-content -->
    </div>
    <div class="card-footer">
      
      <div class="float-right">
        <input type="button" value="Clear" class="btn btn-danger  " v-on:click="clear()" />
        <input type="submit" value="Save Eassy" class="btn btn-success  " />
      </div>

    </div>
  </form>

</template>

<script>
  const axios = require('axios').default;

  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  import { quillEditor } from 'vue-quill-editor'
  export default ({
    components: {
      //VueEditor
      //"vue-html-editor": VueEditor
      quillEditor
    },
    props: {
      employeeId: Number,
    },

    data() {
      return {

        applicantEassy: { 
          Eassy: ''
        },
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {

      pageLoad() {
        startReq();
        var vm = this;
        axios.get('/ApplicantsApi/pageLoadEssay?id=' + vm.employeeId)
          .then(function (res) {
            if (res.data.eassy != null) {
              vm.applicantEassy = res.data.eassy;
            }
            endReq();


          })
          .catch(function (error) {
            console.log(error);
          });
      },

      save(e) {
        e.preventDefault();
        var vm = this;
        startReq();
        axios.post('/ApplicantsApi/saveEssay?id=' + vm.employeeId, {
          eassy: vm.applicantEassy,
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done");
            }
            else
              toastr.error(res.data.msg);

          }).catch(function (err) {
            endReq();
            var res = err.response;
            if (res.status == 401) {
              toastr.error(res.data);
            }
            else {
              for (const [key, value] of Object.entries(res.data.errors)) {
                //console.log(`${value}`);
                toastr.error(`${value}`);
              }
            }
          })
      },

      clear() {
        location.reload();
      }

    }
  })</script>

<style>
  .h4-t {
    margin-top: -9px;
    margin-bottom: -5px;
    font-weight: 600
  }

  .h4-c {
    margin-bottom: -5px;
    font-weight: 600
  }
</style>



// WEBPACK FOOTER //
// src/components/applicantEassy.vue